import React from "react";
import { Button, InputAdornment, MenuItem, TextField } from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import TitleIcon from "@mui/icons-material/Title";
import LinkIcon from "@mui/icons-material/Link";
import CategoryIcon from "@mui/icons-material/Category";

export default function DocumentForm({
  formData,
  handleChangeInputDocument,
  handleInsertDocument,
  isEditing,
  handleUpdateDocument,
}) {
  return (
    <div className="p-6 max-w-3xl mx-auto bg-white shadow-lg rounded-lg mb-[50px]">
      <h2 className="text-2xl font-bold text-center mb-6">
        {isEditing ? "Cập nhật thông tin tài liệu" : "Tạo tài liệu mới"}
      </h2>
      <div className="mb-5 flex justify-around flex-wrap">
        <TextField
          label="Tiêu đề *"
          name="title"
          value={formData?.title}
          className="md:w-[300px] w-[100%] lg:mb-0 mb-5 label-text"
          onChange={handleChangeInputDocument}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <TitleIcon />
              </InputAdornment>
            ),
          }}
          variant="standard"
        />
        <TextField
          label="URL *"
          name="url"
          value={formData?.url}
          onChange={handleChangeInputDocument}
          className="md:w-[300px] w-[100%] label-text"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <LinkIcon />
              </InputAdornment>
            ),
          }}
          variant="standard"
          placeholder="https://..."
        />
      </div>

      <div className="mb-5 flex justify-start flex-wrap ml-7">
        <TextField
          select
          label="Loại tài liệu *"
          name="type"
          value={formData?.type || ""}
          onChange={handleChangeInputDocument}
          className="md:w-[300px] w-[100%] lg:mb-0 mb-5 label-text"
          variant="standard"
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <CategoryIcon />
              </InputAdornment>
            ),
          }}
          InputLabelProps={{
            shrink: true,
          }}
        >
          {[
            { value: "tsa_mock", label: "Đề thi thử TSA" },
            { value: "thpt_mock", label: "Đề thi thử THPT" },
            { value: "tsa_docs", label: "Tài liệu TSA" },
            { value: "thpt_docs", label: "Tài liệu THPT" },
          ].map((option) => (
            <MenuItem key={option.value} value={option.value}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
      </div>

      <div className="mb-5">
        <TextField
          label="Mô tả tài liệu"
          name="description"
          value={formData?.description || ""}
          onChange={handleChangeInputDocument}
          className="w-full"
          variant="outlined"
          multiline
          minRows={3}
          placeholder="Mô tả ngắn gọn về tài liệu..."
        />
      </div>

      <div className="mb-5 flex justify-around flex-wrap px-[130px]">
        {isEditing ? (
          <Button
            variant="contained"
            component="label"
            className="label-text md:w-[250px] w-[100%] py-[10px]"
            startIcon={<CloudUploadIcon />}
            onClick={handleUpdateDocument}
          >
            Cập nhật tài liệu
          </Button>
        ) : (
          <Button
            variant="contained"
            component="label"
            className="label-text md:w-[200px] w-[100%] py-[10px]"
            startIcon={<CloudUploadIcon />}
            onClick={handleInsertDocument}
          >
            Tạo tài liệu
          </Button>
        )}
      </div>
    </div>
  );
}
